import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Target, Zap, Trophy, User } from 'lucide-react';
export function BottomNav() {
  const location = useLocation();
  const navItems = [{
    path: '/',
    icon: Home,
    label: 'Home'
  }, {
    path: '/goals',
    icon: Target,
    label: 'Quests'
  }, {
    path: '/focus',
    icon: Zap,
    label: 'Focus'
  }, {
    path: '/leaderboard',
    icon: Trophy,
    label: 'Ranks'
  }, {
    path: '/profile',
    icon: User,
    label: 'Profile'
  }];
  return <nav className="fixed bottom-0 left-0 right-0 bg-white dark:bg-[#252936] border-t border-gray-100 dark:border-gray-800 z-40" data-id="element-158">
      <div className="flex justify-around items-center h-20 max-w-lg mx-auto px-2" data-id="element-159">
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        return <Link key={item.path} to={item.path} className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${isActive ? 'text-game-purple' : 'text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300'}`} data-id="element-160">
              <div className={`p-2 rounded-2xl transition-all ${isActive ? 'bg-game-bg-purple' : ''}`} data-id="element-161">
                <Icon className="w-6 h-6" data-id="element-162" />
              </div>
              <span className="text-xs font-quicksand font-bold mt-1" data-id="element-163">
                {item.label}
              </span>
            </Link>;
      })}
      </div>
    </nav>;
}